var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorror({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/horror"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.871 20.542v.756m0 0c0 1.042-.7 1.702-1.564 1.702-.864 0-1.565-.66-1.565-1.701v-2.732c.364-2.08-3.963-1.943-3.963-8.555C1.779 5.035 6.355 1 12 1c5.645 0 10.221 4.035 10.221 9.012-.008 6.64-4.331 6.407-3.963 8.695v2.592c0 1.04-.7 1.701-1.564 1.701-.864 0-1.565-.66-1.565-1.701m-6.258 0c0 1.04.7 1.701 1.565 1.701C11.3 23 12 22.34 12 21.299m0-.757v.756m0 0C12 22.34 12.7 23 13.565 23c.864 0 1.564-.66 1.564-1.701m0-.757v.756m-2.845-5.847c.745 0 1.063.895 1.28 1.72.064.24-.2.392-.424.277-.42-.217-.478-.324-.856-.318m0-1.68c-.75 0-1.07.892-1.284 1.72-.061.239.197.39.42.28.437-.22.498-.314.864-.32m0-1.68v1.68m6.216-6.396c0-3.845-4.935-3.845-4.935 0 0 3.789 4.935 3.789 4.935 0Zm-8.064 0c0-3.845-4.936-3.845-4.936 0 0 3.789 4.936 3.789 4.936 0Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorror);
export default __webpack_public_path__ + "static/media/horror.8d00ca3b896f40eb9470e8b2f78546af.svg";
export { ForwardRef as ReactComponent };